import getConfig from 'next/config';
import { useEffect, useState } from 'react';
import EirActionModal from '../eir-action-modal/EirActionModal';
import fetchInfo from '../../../util/fetchModalData';

const { publicRuntimeConfig } = getConfig();

const RemoveConfirmationModal = ({ openConfirmationModal, cartItemName, removeItems }) => {
  const handleOk = () => {
    openConfirmationModal.disable();
  };

  const [cmsCollectionData, setCmsCollectionData] = useState({});
  const [load, setLoad] = useState(true);

  const getCmsData = async () => {
    try {
      const data = await fetchInfo({
        collectionType: 'eir-action-modals',
        modalID: 'OS-remove_from_cart',
      });
      if (Object?.keys(data).length !== 0) {
        setLoad(false);
        setCmsCollectionData(data);
      }
    } catch (error) {
      console.error('error', error);
    }
  };

  useEffect(() => {
    getCmsData();
  }, []);

  return (
    <EirActionModal
      id={cmsCollectionData?.attributes?.modalID}
      open={openConfirmationModal.value}
      handleClose={openConfirmationModal.disable}
      iconSrc={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${cmsCollectionData?.attributes?.iconSrc?.data?.attributes?.url}`}
      iconAlt={cmsCollectionData?.attributes?.iconSrc?.data?.attributes?.alternativeText}
      title={cmsCollectionData?.attributes?.title}
      description={`${
        cmsCollectionData?.attributes?.firstHalfDescription &&
        cmsCollectionData?.attributes?.firstHalfDescription
      }
       <b>${cartItemName}</b>
         ${
           cmsCollectionData?.attributes?.secondHalfDescription &&
           cmsCollectionData?.attributes?.secondHalfDescription
         }`}
      cta={[
        {
          // text: `No, I'll keep it`,
          text: cmsCollectionData?.attributes?.cta[0]?.name
            ? cmsCollectionData?.attributes?.cta[0]?.name
            : `No, I'll keep it`,
          ariaLabel: cmsCollectionData?.attributes?.cta[0]?.ariaLabel
            ? cmsCollectionData?.attributes?.cta[0]?.ariaLabel
            : '',
          type: 'solid',

          action: () => handleOk(openConfirmationModal),
        },
        {
          // text: 'Yes, remove it',
          text: cmsCollectionData?.attributes?.cta[1]?.name
            ? cmsCollectionData?.attributes?.cta[1]?.name
            : 'Yes, remove it',
          ariaLabel: cmsCollectionData?.attributes?.cta[1]?.ariaLabel
            ? cmsCollectionData?.attributes?.cta[1]?.ariaLabel
            : '',
          type: 'contained',
          action: () => removeItems(),
        },
      ]}
      disableCloseOnBackdropClick
      disableCloseOnEscapeKeyDown
      disablecta={false}
      load={load}
    />
  );
};
export default RemoveConfirmationModal;
